(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'kvision-js-legacy', 'kvision-kvision-jquery-js-legacy', 'jquery', 'jquery-kotlin-jsLegacy'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('kvision-js-legacy'), require('kvision-kvision-jquery-js-legacy'), require('jquery'), require('jquery-kotlin-jsLegacy'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-datetime-js-legacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-kvision-bootstrap-datetime-js-legacy'.");
    }if (typeof this['kvision-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-datetime-js-legacy'. Its dependency 'kvision-js-legacy' was not found. Please, check whether 'kvision-js-legacy' is loaded prior to 'kvision-kvision-bootstrap-datetime-js-legacy'.");
    }if (typeof this['kvision-kvision-jquery-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-datetime-js-legacy'. Its dependency 'kvision-kvision-jquery-js-legacy' was not found. Please, check whether 'kvision-kvision-jquery-js-legacy' is loaded prior to 'kvision-kvision-bootstrap-datetime-js-legacy'.");
    }if (typeof jQuery === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-datetime-js-legacy'. Its dependency 'jquery' was not found. Please, check whether 'jquery' is loaded prior to 'kvision-kvision-bootstrap-datetime-js-legacy'.");
    }if (typeof this['jquery-kotlin-jsLegacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-datetime-js-legacy'. Its dependency 'jquery-kotlin-jsLegacy' was not found. Please, check whether 'jquery-kotlin-jsLegacy' is loaded prior to 'kvision-kvision-bootstrap-datetime-js-legacy'.");
    }root['kvision-kvision-bootstrap-datetime-js-legacy'] = factory(typeof this['kvision-kvision-bootstrap-datetime-js-legacy'] === 'undefined' ? {} : this['kvision-kvision-bootstrap-datetime-js-legacy'], kotlin, this['kvision-js-legacy'], this['kvision-kvision-jquery-js-legacy'], jQuery, this['jquery-kotlin-jsLegacy']);
  }
}(this, function (_, Kotlin, $module$kvision_js_legacy, $module$kvision_kvision_jquery_js_legacy, $module$jquery, $module$jquery_kotlin_jsLegacy) {
  'use strict';
  var $$importsForInline$$ = _.$$importsForInline$$ || (_.$$importsForInline$$ = {});
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var ModuleInitializer = $module$kvision_js_legacy.io.kvision.ModuleInitializer;
  var SimplePanel = $module$kvision_js_legacy.io.kvision.panel.SimplePanel;
  var FieldLabel = $module$kvision_js_legacy.io.kvision.form.FieldLabel;
  var InvalidFeedback = $module$kvision_js_legacy.io.kvision.form.InvalidFeedback;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var DateFormControl = $module$kvision_js_legacy.io.kvision.form.DateFormControl;
  var MutableState = $module$kvision_js_legacy.io.kvision.state.MutableState;
  var throwUPAE = Kotlin.throwUPAE;
  var toDateF = $module$kvision_js_legacy.io.kvision.types.toDateF_rjktp$;
  var toStringF = $module$kvision_js_legacy.io.kvision.types.toStringF_i82nfv$;
  var PropertyMetadata = Kotlin.PropertyMetadata;
  var getElementJQueryD = $module$kvision_kvision_jquery_js_legacy.io.kvision.core.getElementJQueryD_tqt9mm$;
  var contains = Kotlin.kotlin.text.contains_li3zpu$;
  var i18n = $module$kvision_js_legacy.io.kvision.i18n;
  var Unit = Kotlin.kotlin.Unit;
  var getElementJQuery = $module$kvision_kvision_jquery_js_legacy.io.kvision.core.getElementJQuery_tqt9mm$;
  var equals = Kotlin.equals;
  var numberToInt = Kotlin.numberToInt;
  var bindAllJQueryListeners = $module$kvision_kvision_jquery_js_legacy.io.kvision.core.bindAllJQueryListeners_yw480n$;
  var removeAllJQueryListeners = $module$kvision_kvision_jquery_js_legacy.io.kvision.core.removeAllJQueryListeners_yw480n$;
  var TextInput = $module$kvision_js_legacy.io.kvision.form.text.TextInput;
  var icon = $module$kvision_js_legacy.io.kvision.html.icon_6utwb9$;
  var Span = $module$kvision_js_legacy.io.kvision.html.Span;
  var GenericFormComponent = $module$kvision_js_legacy.io.kvision.form.GenericFormComponent;
  var FormInput = $module$kvision_js_legacy.io.kvision.form.FormInput;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_287e2$;
  var Widget$Widget$RefreshDelegateProvider_init = $module$kvision_js_legacy.io.kvision.core.Widget.RefreshDelegateProvider;
  var Object_init = Object;
  DateTime.prototype = Object.create(SimplePanel.prototype);
  DateTime.prototype.constructor = DateTime;
  DateTimeInput.prototype = Object.create(SimplePanel.prototype);
  DateTimeInput.prototype.constructor = DateTimeInput;
  function BootstrapDatetimeModule() {
    BootstrapDatetimeModule_instance = this;
  }
  BootstrapDatetimeModule.prototype.initialize = function () {
    require('pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.min.css');
    require('pc-bootstrap4-datetimepicker');
  };
  BootstrapDatetimeModule.$metadata$ = {kind: Kind_OBJECT, simpleName: 'BootstrapDatetimeModule', interfaces: [ModuleInitializer]};
  var BootstrapDatetimeModule_instance = null;
  function BootstrapDatetimeModule_getInstance() {
    if (BootstrapDatetimeModule_instance === null) {
      new BootstrapDatetimeModule();
    }return BootstrapDatetimeModule_instance;
  }
  function DateTime(value, name, format, label, rich, init) {
    DateTime$Companion_getInstance();
    if (value === void 0)
      value = null;
    if (name === void 0)
      name = null;
    if (format === void 0)
      format = 'YYYY-MM-DD HH:mm';
    if (label === void 0)
      label = null;
    if (rich === void 0)
      rich = false;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, 'form-group kv-mb-3');
    this.idc_umhuwl$_0 = 'kv_form_time_' + DateTime$Companion_getInstance().counter_8be2vx$;
    var $receiver = new DateTimeInput(value, format);
    var closure$name = name;
    $receiver.input.id = this.idc_umhuwl$_0;
    $receiver.name = closure$name;
    this.input_nkbqon$_0 = $receiver;
    this.flabel_5m97ir$_0 = new FieldLabel(this.idc_umhuwl$_0, label, rich, 'form-label');
    var $receiver_0 = new InvalidFeedback();
    $receiver_0.visible = false;
    this.invalidFeedback_pnkvjd$_0 = $receiver_0;
    var tmp$;
    this.input.eventTarget = this;
    this.addPrivate_87eobz$(this.flabel);
    this.addPrivate_87eobz$(this.input);
    this.addPrivate_87eobz$(this.invalidFeedback);
    tmp$ = DateTime$Companion_getInstance().counter_8be2vx$;
    DateTime$Companion_getInstance().counter_8be2vx$ = tmp$ + 1 | 0;
    init != null ? init(this) : null;
  }
  Object.defineProperty(DateTime.prototype, 'value', {configurable: true, get: function () {
    return this.input.value;
  }, set: function (value) {
    this.input.value = value;
  }});
  Object.defineProperty(DateTime.prototype, 'format', {configurable: true, get: function () {
    return this.input.format;
  }, set: function (value) {
    this.input.format = value;
  }});
  Object.defineProperty(DateTime.prototype, 'placeholder', {configurable: true, get: function () {
    return this.input.placeholder;
  }, set: function (value) {
    this.input.placeholder = value;
  }});
  Object.defineProperty(DateTime.prototype, 'autofocus', {configurable: true, get: function () {
    return this.input.autofocus;
  }, set: function (value) {
    this.input.autofocus = value;
  }});
  Object.defineProperty(DateTime.prototype, 'readonly', {configurable: true, get: function () {
    return this.input.readonly;
  }, set: function (value) {
    this.input.readonly = value;
  }});
  Object.defineProperty(DateTime.prototype, 'daysOfWeekDisabled', {configurable: true, get: function () {
    return this.input.daysOfWeekDisabled;
  }, set: function (value) {
    this.input.daysOfWeekDisabled = value;
  }});
  Object.defineProperty(DateTime.prototype, 'showClear', {configurable: true, get: function () {
    return this.input.showClear;
  }, set: function (value) {
    this.input.showClear = value;
  }});
  Object.defineProperty(DateTime.prototype, 'showClose', {configurable: true, get: function () {
    return this.input.showClose;
  }, set: function (value) {
    this.input.showClose = value;
  }});
  Object.defineProperty(DateTime.prototype, 'showTodayButton', {configurable: true, get: function () {
    return this.input.showTodayButton;
  }, set: function (value) {
    this.input.showTodayButton = value;
  }});
  Object.defineProperty(DateTime.prototype, 'stepping', {configurable: true, get: function () {
    return this.input.stepping;
  }, set: function (value) {
    this.input.stepping = value;
  }});
  Object.defineProperty(DateTime.prototype, 'minDate', {configurable: true, get: function () {
    return this.input.minDate;
  }, set: function (value) {
    this.input.minDate = value;
  }});
  Object.defineProperty(DateTime.prototype, 'maxDate', {configurable: true, get: function () {
    return this.input.maxDate;
  }, set: function (value) {
    this.input.maxDate = value;
  }});
  Object.defineProperty(DateTime.prototype, 'sideBySide', {configurable: true, get: function () {
    return this.input.sideBySide;
  }, set: function (value) {
    this.input.sideBySide = value;
  }});
  Object.defineProperty(DateTime.prototype, 'enabledDates', {configurable: true, get: function () {
    return this.input.enabledDates;
  }, set: function (value) {
    this.input.enabledDates = value;
  }});
  Object.defineProperty(DateTime.prototype, 'disabledDates', {configurable: true, get: function () {
    return this.input.disabledDates;
  }, set: function (value) {
    this.input.disabledDates = value;
  }});
  Object.defineProperty(DateTime.prototype, 'ignoreReadonly', {configurable: true, get: function () {
    return this.input.ignoreReadonly;
  }, set: function (value) {
    this.input.ignoreReadonly = value;
  }});
  Object.defineProperty(DateTime.prototype, 'inline', {configurable: true, get: function () {
    return this.input.inline;
  }, set: function (value) {
    this.input.inline = value;
  }});
  Object.defineProperty(DateTime.prototype, 'keepOpen', {configurable: true, get: function () {
    return this.input.keepOpen;
  }, set: function (value) {
    this.input.keepOpen = value;
  }});
  Object.defineProperty(DateTime.prototype, 'focusOnShow', {configurable: true, get: function () {
    return this.input.focusOnShow;
  }, set: function (value) {
    this.input.focusOnShow = value;
  }});
  Object.defineProperty(DateTime.prototype, 'label', {configurable: true, get: function () {
    return this.flabel.content;
  }, set: function (value) {
    this.flabel.content = value;
  }});
  Object.defineProperty(DateTime.prototype, 'rich', {configurable: true, get: function () {
    return this.flabel.rich;
  }, set: function (value) {
    this.flabel.rich = value;
  }});
  Object.defineProperty(DateTime.prototype, 'input', {configurable: true, get: function () {
    return this.input_nkbqon$_0;
  }});
  Object.defineProperty(DateTime.prototype, 'flabel', {configurable: true, get: function () {
    return this.flabel_5m97ir$_0;
  }});
  Object.defineProperty(DateTime.prototype, 'invalidFeedback', {configurable: true, get: function () {
    return this.invalidFeedback_pnkvjd$_0;
  }});
  DateTime.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    if (this.validatorError != null) {
      classSetBuilder.add_61zpoe$('text-danger');
    }};
  DateTime.prototype.setEventListener_a1up2z$ = function (block) {
    return this.input.setEventListener_a1up2z$(block);
  };
  DateTime.prototype.removeEventListener_za3lpa$ = function (id) {
    this.input.removeEventListener_za3lpa$(id);
    return this;
  };
  DateTime.prototype.removeEventListeners = function () {
    this.input.removeEventListeners();
    return this;
  };
  DateTime.prototype.showPopup = function () {
    this.input.showPopup();
  };
  DateTime.prototype.hidePopup = function () {
    this.input.hidePopup();
  };
  DateTime.prototype.togglePopup = function () {
    this.input.togglePopup();
  };
  DateTime.prototype.getValueAsString = function () {
    return this.input.getValueAsString();
  };
  DateTime.prototype.focus = function () {
    this.input.focus();
  };
  DateTime.prototype.blur = function () {
    this.input.blur();
  };
  DateTime.prototype.getState = function () {
    return this.input.getState();
  };
  DateTime.prototype.subscribe_qlkmfe$ = function (observer) {
    return this.input.subscribe_qlkmfe$(observer);
  };
  DateTime.prototype.setState_11rb$ = function (state) {
    this.input.setState_11rb$(state);
  };
  function DateTime$Companion() {
    DateTime$Companion_instance = this;
    this.counter_8be2vx$ = 0;
  }
  DateTime$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var DateTime$Companion_instance = null;
  function DateTime$Companion_getInstance() {
    if (DateTime$Companion_instance === null) {
      new DateTime$Companion();
    }return DateTime$Companion_instance;
  }
  DateTime.$metadata$ = {kind: Kind_CLASS, simpleName: 'DateTime', interfaces: [MutableState, DateFormControl, SimplePanel]};
  var DEFAULT_STEPPING;
  function DateTimeInput(value, format, className, init) {
    DateTimeInput$Companion_getInstance();
    if (value === void 0)
      value = null;
    if (format === void 0)
      format = 'YYYY-MM-DD HH:mm';
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var tmp$;
    SimplePanel.call(this, ((tmp$ = className != null ? className + ' ' : null) != null ? tmp$ : '') + 'input-group date');
    this.observers = ArrayList_init();
    this.initialized_z5wnwf$_0 = false;
    this.input = new TextInput(void 0, value != null ? toStringF(value, format) : null);
    this.icon_w65uco$_t3bioe$_0 = this.icon_w65uco$_t3bioe$_0;
    this.addon_wjs4t$_0 = new Span(void 0, void 0, void 0, 'input-group-text datepickerbutton', DateTimeInput$addon$lambda(this, format));
    this.format_k90eja$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, format, DateTimeInput$format$lambda(this))).provideDelegate_n5byny$(this, DateTimeInput$format_metadata);
    this.daysOfWeekDisabled_637hxf$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, [], DateTimeInput$daysOfWeekDisabled$lambda(this))).provideDelegate_n5byny$(this, DateTimeInput$daysOfWeekDisabled_metadata);
    this.showClear_bmw5od$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, true, DateTimeInput$showClear$lambda(this))).provideDelegate_n5byny$(this, DateTimeInput$showClear_metadata);
    this.showClose_bmpers$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, true, DateTimeInput$showClose$lambda(this))).provideDelegate_n5byny$(this, DateTimeInput$showClose_metadata);
    this.showTodayButton_hy8dtv$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, true, DateTimeInput$showTodayButton$lambda(this))).provideDelegate_n5byny$(this, DateTimeInput$showTodayButton_metadata);
    this.stepping_5jid31$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, 5, DateTimeInput$stepping$lambda(this))).provideDelegate_n5byny$(this, DateTimeInput$stepping_metadata);
    this.minDate_jdajil$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, DateTimeInput$minDate$lambda(this))).provideDelegate_n5byny$(this, DateTimeInput$minDate_metadata);
    this.maxDate_a07ild$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, DateTimeInput$maxDate$lambda(this))).provideDelegate_n5byny$(this, DateTimeInput$maxDate_metadata);
    this.sideBySide_5hmnfg$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, false, DateTimeInput$sideBySide$lambda(this))).provideDelegate_n5byny$(this, DateTimeInput$sideBySide_metadata);
    this.enabledDates_hhj4e5$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, [], DateTimeInput$enabledDates$lambda(this))).provideDelegate_n5byny$(this, DateTimeInput$enabledDates_metadata);
    this.disabledDates_r7nruy$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, [], DateTimeInput$disabledDates$lambda(this))).provideDelegate_n5byny$(this, DateTimeInput$disabledDates_metadata);
    this.ignoreReadonly_njxbn7$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, false, DateTimeInput$ignoreReadonly$lambda(this))).provideDelegate_n5byny$(this, DateTimeInput$ignoreReadonly_metadata);
    this.inline_n7rrig$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, false, DateTimeInput$inline$lambda(this))).provideDelegate_n5byny$(this, DateTimeInput$inline_metadata);
    this.keepOpen_duby2a$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, false, DateTimeInput$keepOpen$lambda(this))).provideDelegate_n5byny$(this, DateTimeInput$keepOpen_metadata);
    this.focusOnShow_da5l5r$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, true, DateTimeInput$focusOnShow$lambda(this))).provideDelegate_n5byny$(this, DateTimeInput$focusOnShow_metadata);
    this.useSnabbdomDistinctKey();
    this.addPrivate_87eobz$(this.input);
    this.addPrivate_87eobz$(this.addon_wjs4t$_0);
    init != null ? init(this) : null;
  }
  Object.defineProperty(DateTimeInput.prototype, 'icon_w65uco$_0', {configurable: true, get: function () {
    if (this.icon_w65uco$_t3bioe$_0 == null)
      return throwUPAE('icon');
    return this.icon_w65uco$_t3bioe$_0;
  }, set: function (icon) {
    this.icon_w65uco$_t3bioe$_0 = icon;
  }});
  Object.defineProperty(DateTimeInput.prototype, 'value', {configurable: true, get: function () {
    var tmp$;
    return (tmp$ = this.input.value) != null ? toDateF(tmp$, this.format) : null;
  }, set: function (value) {
    this.input.value = value != null ? toStringF(value, this.format) : null;
    this.refreshState_cq39th$_0();
  }});
  var DateTimeInput$format_metadata = new PropertyMetadata('format');
  Object.defineProperty(DateTimeInput.prototype, 'format', {configurable: true, get: function () {
    return this.format_k90eja$_0.getValue_fmbzy8$(this, DateTimeInput$format_metadata);
  }, set: function (format) {
    this.format_k90eja$_0.setValue_19qrsr$(this, DateTimeInput$format_metadata, format);
  }});
  Object.defineProperty(DateTimeInput.prototype, 'placeholder', {configurable: true, get: function () {
    return this.input.placeholder;
  }, set: function (value) {
    this.input.placeholder = value;
  }});
  Object.defineProperty(DateTimeInput.prototype, 'name', {configurable: true, get: function () {
    return this.input.name;
  }, set: function (value) {
    this.input.name = value;
  }});
  Object.defineProperty(DateTimeInput.prototype, 'disabled', {configurable: true, get: function () {
    return this.input.disabled;
  }, set: function (value) {
    this.input.disabled = value;
  }});
  Object.defineProperty(DateTimeInput.prototype, 'autofocus', {configurable: true, get: function () {
    return this.input.autofocus;
  }, set: function (value) {
    this.input.autofocus = value;
  }});
  Object.defineProperty(DateTimeInput.prototype, 'readonly', {configurable: true, get: function () {
    return this.input.readonly;
  }, set: function (value) {
    this.input.readonly = value;
  }});
  Object.defineProperty(DateTimeInput.prototype, 'size', {configurable: true, get: function () {
    return this.input.size;
  }, set: function (value) {
    this.input.size = value;
  }});
  Object.defineProperty(DateTimeInput.prototype, 'validationStatus', {configurable: true, get: function () {
    return this.input.validationStatus;
  }, set: function (value) {
    this.input.validationStatus = value;
    this.refresh();
  }});
  var DateTimeInput$daysOfWeekDisabled_metadata = new PropertyMetadata('daysOfWeekDisabled');
  Object.defineProperty(DateTimeInput.prototype, 'daysOfWeekDisabled', {configurable: true, get: function () {
    return this.daysOfWeekDisabled_637hxf$_0.getValue_fmbzy8$(this, DateTimeInput$daysOfWeekDisabled_metadata);
  }, set: function (daysOfWeekDisabled) {
    this.daysOfWeekDisabled_637hxf$_0.setValue_19qrsr$(this, DateTimeInput$daysOfWeekDisabled_metadata, daysOfWeekDisabled);
  }});
  var DateTimeInput$showClear_metadata = new PropertyMetadata('showClear');
  Object.defineProperty(DateTimeInput.prototype, 'showClear', {configurable: true, get: function () {
    return this.showClear_bmw5od$_0.getValue_fmbzy8$(this, DateTimeInput$showClear_metadata);
  }, set: function (showClear) {
    this.showClear_bmw5od$_0.setValue_19qrsr$(this, DateTimeInput$showClear_metadata, showClear);
  }});
  var DateTimeInput$showClose_metadata = new PropertyMetadata('showClose');
  Object.defineProperty(DateTimeInput.prototype, 'showClose', {configurable: true, get: function () {
    return this.showClose_bmpers$_0.getValue_fmbzy8$(this, DateTimeInput$showClose_metadata);
  }, set: function (showClose) {
    this.showClose_bmpers$_0.setValue_19qrsr$(this, DateTimeInput$showClose_metadata, showClose);
  }});
  var DateTimeInput$showTodayButton_metadata = new PropertyMetadata('showTodayButton');
  Object.defineProperty(DateTimeInput.prototype, 'showTodayButton', {configurable: true, get: function () {
    return this.showTodayButton_hy8dtv$_0.getValue_fmbzy8$(this, DateTimeInput$showTodayButton_metadata);
  }, set: function (showTodayButton) {
    this.showTodayButton_hy8dtv$_0.setValue_19qrsr$(this, DateTimeInput$showTodayButton_metadata, showTodayButton);
  }});
  var DateTimeInput$stepping_metadata = new PropertyMetadata('stepping');
  Object.defineProperty(DateTimeInput.prototype, 'stepping', {configurable: true, get: function () {
    return this.stepping_5jid31$_0.getValue_fmbzy8$(this, DateTimeInput$stepping_metadata);
  }, set: function (stepping) {
    this.stepping_5jid31$_0.setValue_19qrsr$(this, DateTimeInput$stepping_metadata, stepping);
  }});
  var DateTimeInput$minDate_metadata = new PropertyMetadata('minDate');
  Object.defineProperty(DateTimeInput.prototype, 'minDate', {configurable: true, get: function () {
    return this.minDate_jdajil$_0.getValue_fmbzy8$(this, DateTimeInput$minDate_metadata);
  }, set: function (minDate) {
    this.minDate_jdajil$_0.setValue_19qrsr$(this, DateTimeInput$minDate_metadata, minDate);
  }});
  var DateTimeInput$maxDate_metadata = new PropertyMetadata('maxDate');
  Object.defineProperty(DateTimeInput.prototype, 'maxDate', {configurable: true, get: function () {
    return this.maxDate_a07ild$_0.getValue_fmbzy8$(this, DateTimeInput$maxDate_metadata);
  }, set: function (maxDate) {
    this.maxDate_a07ild$_0.setValue_19qrsr$(this, DateTimeInput$maxDate_metadata, maxDate);
  }});
  var DateTimeInput$sideBySide_metadata = new PropertyMetadata('sideBySide');
  Object.defineProperty(DateTimeInput.prototype, 'sideBySide', {configurable: true, get: function () {
    return this.sideBySide_5hmnfg$_0.getValue_fmbzy8$(this, DateTimeInput$sideBySide_metadata);
  }, set: function (sideBySide) {
    this.sideBySide_5hmnfg$_0.setValue_19qrsr$(this, DateTimeInput$sideBySide_metadata, sideBySide);
  }});
  var DateTimeInput$enabledDates_metadata = new PropertyMetadata('enabledDates');
  Object.defineProperty(DateTimeInput.prototype, 'enabledDates', {configurable: true, get: function () {
    return this.enabledDates_hhj4e5$_0.getValue_fmbzy8$(this, DateTimeInput$enabledDates_metadata);
  }, set: function (enabledDates) {
    this.enabledDates_hhj4e5$_0.setValue_19qrsr$(this, DateTimeInput$enabledDates_metadata, enabledDates);
  }});
  var DateTimeInput$disabledDates_metadata = new PropertyMetadata('disabledDates');
  Object.defineProperty(DateTimeInput.prototype, 'disabledDates', {configurable: true, get: function () {
    return this.disabledDates_r7nruy$_0.getValue_fmbzy8$(this, DateTimeInput$disabledDates_metadata);
  }, set: function (disabledDates) {
    this.disabledDates_r7nruy$_0.setValue_19qrsr$(this, DateTimeInput$disabledDates_metadata, disabledDates);
  }});
  var DateTimeInput$ignoreReadonly_metadata = new PropertyMetadata('ignoreReadonly');
  Object.defineProperty(DateTimeInput.prototype, 'ignoreReadonly', {configurable: true, get: function () {
    return this.ignoreReadonly_njxbn7$_0.getValue_fmbzy8$(this, DateTimeInput$ignoreReadonly_metadata);
  }, set: function (ignoreReadonly) {
    this.ignoreReadonly_njxbn7$_0.setValue_19qrsr$(this, DateTimeInput$ignoreReadonly_metadata, ignoreReadonly);
  }});
  var DateTimeInput$inline_metadata = new PropertyMetadata('inline');
  Object.defineProperty(DateTimeInput.prototype, 'inline', {configurable: true, get: function () {
    return this.inline_n7rrig$_0.getValue_fmbzy8$(this, DateTimeInput$inline_metadata);
  }, set: function (inline) {
    this.inline_n7rrig$_0.setValue_19qrsr$(this, DateTimeInput$inline_metadata, inline);
  }});
  var DateTimeInput$keepOpen_metadata = new PropertyMetadata('keepOpen');
  Object.defineProperty(DateTimeInput.prototype, 'keepOpen', {configurable: true, get: function () {
    return this.keepOpen_duby2a$_0.getValue_fmbzy8$(this, DateTimeInput$keepOpen_metadata);
  }, set: function (keepOpen) {
    this.keepOpen_duby2a$_0.setValue_19qrsr$(this, DateTimeInput$keepOpen_metadata, keepOpen);
  }});
  var DateTimeInput$focusOnShow_metadata = new PropertyMetadata('focusOnShow');
  Object.defineProperty(DateTimeInput.prototype, 'focusOnShow', {configurable: true, get: function () {
    return this.focusOnShow_da5l5r$_0.getValue_fmbzy8$(this, DateTimeInput$focusOnShow_metadata);
  }, set: function (focusOnShow) {
    this.focusOnShow_da5l5r$_0.setValue_19qrsr$(this, DateTimeInput$focusOnShow_metadata, focusOnShow);
  }});
  DateTimeInput.prototype.refreshState_cq39th$_0 = function () {
    if (this.initialized_z5wnwf$_0)
      getElementJQueryD(this).data('DateTimePicker').date(this.value);
  };
  DateTimeInput.prototype.getIconClass_gz0f8m$_0 = function (format) {
    var tmp$;
    if (contains(format, 'YYYY') || contains(format, 'MM') || contains(format, 'DD')) {
      tmp$ = 'fas fa-calendar-alt';
    } else {
      tmp$ = 'fas fa-clock';
    }
    return tmp$;
  };
  DateTimeInput.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    classSetBuilder.add_vqcfem$(this.validationStatus);
  };
  DateTimeInput.prototype.refreshDatePicker = function () {
    var tmp$;
    if (this.initialized_z5wnwf$_0) {
      ((tmp$ = getElementJQueryD(this)) != null ? tmp$.data('DateTimePicker') : null).destroy();
    }this.input.visible = !this.inline;
    this.addon_wjs4t$_0.visible = !this.inline;
    this.initDateTimePicker_cv7py0$_0();
    this.icon_w65uco$_0.icon = this.getIconClass_gz0f8m$_0(this.format);
  };
  DateTimeInput.prototype.showPopup = function () {
    var tmp$;
    if (this.initialized_z5wnwf$_0)
      ((tmp$ = getElementJQueryD(this)) != null ? tmp$.data('DateTimePicker') : null).show();
  };
  DateTimeInput.prototype.hidePopup = function () {
    var tmp$;
    if (this.initialized_z5wnwf$_0)
      ((tmp$ = getElementJQueryD(this)) != null ? tmp$.data('DateTimePicker') : null).hide();
  };
  DateTimeInput.prototype.togglePopup = function () {
    var tmp$;
    if (this.initialized_z5wnwf$_0)
      ((tmp$ = getElementJQueryD(this)) != null ? tmp$.data('DateTimePicker') : null).toggle();
  };
  DateTimeInput.prototype.afterInsert_77isfd$ = function (node) {
    this.initDateTimePicker_cv7py0$_0();
    this.initEventHandlers_93gwzk$_0();
    this.initialized_z5wnwf$_0 = true;
  };
  DateTimeInput.prototype.afterDestroy = function () {
    var tmp$, tmp$_0;
    if (this.initialized_z5wnwf$_0) {
      (tmp$_0 = (tmp$ = getElementJQueryD(this)) != null ? tmp$.data('DateTimePicker') : null) != null ? tmp$_0.destroy() : null;
      this.initialized_z5wnwf$_0 = false;
    }};
  function DateTimeInput$initDateTimePicker$lambda$lambda$lambda(closure$self) {
    return function () {
      closure$self.togglePopup();
      return Unit;
    };
  }
  DateTimeInput.prototype.initDateTimePicker_cv7py0$_0 = function () {
    var tmp$;
    var language = i18n.I18n.language;
    var self_0 = this;
    if ((tmp$ = getElementJQueryD(this)) != null) {
      var $receiver = new Object_init();
      $receiver.useCurrent = this.inline;
      $receiver.defaultDate = this.inline ? this.value : undefined;
      $receiver.format = this.format;
      $receiver.stepping = this.stepping;
      $receiver.showClear = this.showClear;
      $receiver.showClose = this.showClose;
      $receiver.showTodayButton = this.showTodayButton;
      $receiver.sideBySide = this.sideBySide;
      $receiver.ignoreReadonly = this.ignoreReadonly;
      if (this.minDate != null)
        $receiver.minDate = this.minDate;
      if (this.maxDate != null)
        $receiver.maxDate = this.maxDate;
      if (!(this.daysOfWeekDisabled.length === 0))
        $receiver.daysOfWeekDisabled = this.daysOfWeekDisabled;
      if (!(this.enabledDates.length === 0))
        $receiver.enabledDates = this.enabledDates;
      if (!(this.disabledDates.length === 0))
        $receiver.disabledDates = this.disabledDates;
      $receiver.inline = this.inline;
      $receiver.keepOpen = this.keepOpen;
      $receiver.focusOnShow = this.focusOnShow;
      $receiver.locale = language;
      var $receiver_0 = new Object_init();
      $receiver_0.time = 'far fa-clock';
      $receiver_0.date = 'far fa-calendar';
      $receiver_0.up = 'fas fa-arrow-up';
      $receiver_0.down = 'fas fa-arrow-down';
      $receiver_0.previous = 'fas fa-chevron-left';
      $receiver_0.next = 'fas fa-chevron-right';
      $receiver_0.today = 'fas fa-calendar-check';
      $receiver_0.clear = 'far fa-trash-alt';
      $receiver_0.close = 'far fa-times-circle';
      $receiver.icons = $receiver_0;
      var $receiver_1 = new Object_init();
      $receiver_1.today = '';
      $receiver_1.clear = '';
      $receiver_1.close = '';
      $receiver_1.selectMonth = '';
      $receiver_1.prevMonth = '';
      $receiver_1.nextMonth = '';
      $receiver_1.selectYear = '';
      $receiver_1.prevYear = '';
      $receiver_1.nextYear = '';
      $receiver_1.selectDecade = '';
      $receiver_1.prevDecade = '';
      $receiver_1.nextDecade = '';
      $receiver_1.prevCentury = '';
      $receiver_1.nextCentury = '';
      $receiver_1.pickHour = '';
      $receiver_1.incrementHour = '';
      $receiver_1.decrementHour = '';
      $receiver_1.pickMinute = '';
      $receiver_1.incrementMinute = '';
      $receiver_1.decrementMinute = '';
      $receiver_1.pickSecond = '';
      $receiver_1.incrementSecond = '';
      $receiver_1.decrementSecond = '';
      $receiver_1.togglePeriod = '';
      $receiver_1.selectTime = '';
      $receiver.tooltips = $receiver_1;
      var $receiver_2 = new Object_init();
      $receiver_2.enter = DateTimeInput$initDateTimePicker$lambda$lambda$lambda(self_0);
      $receiver.keyBinds = $receiver_2;
      tmp$.datetimepicker($receiver);
    }};
  function DateTimeInput$initEventHandlers$lambda(this$DateTimeInput) {
    return function (e, f) {
      var moment = e.date;
      if (moment) {
        this$DateTimeInput.value = moment.toDate();
      } else {
        this$DateTimeInput.value = null;
      }
      var tmp$ = this$DateTimeInput;
      var $receiver = new Object_init();
      $receiver.detail = e;
      return tmp$.dispatchEvent_nxedta$('change', $receiver);
    };
  }
  function DateTimeInput$initEventHandlers$lambda_0(this$DateTimeInput) {
    return function (e, f) {
      this$DateTimeInput.value = null;
      var tmp$ = this$DateTimeInput;
      var $receiver = new Object_init();
      $receiver.detail = e;
      return tmp$.dispatchEvent_nxedta$('change', $receiver);
    };
  }
  function DateTimeInput$initEventHandlers$lambda_1(this$DateTimeInput) {
    return function (f, f_0) {
      var tmp$, tmp$_0;
      var inTabulator = equals((tmp$_0 = (tmp$ = getElementJQuery(this$DateTimeInput)) != null ? tmp$.closest('.tabulator-cell') : null) != null ? tmp$_0.length : null, 1);
      if (inTabulator) {
        var datepicker = $module$jquery('body').find('.bootstrap-datetimepicker-widget:last');
        var position = datepicker.offset();
        var parent = datepicker.parent();
        var parentPos = parent.offset();
        var width = datepicker.width();
        var parentWid = parent.width();
        datepicker.appendTo('body');
        var $receiver = new Object_init();
        $receiver.position = 'absolute';
        $receiver.top = position.top;
        $receiver.bottom = 'auto';
        $receiver.left = position.left;
        $receiver.right = 'auto';
        datepicker.css($receiver);
        if ((numberToInt(parentPos.left) + numberToInt(parentWid) | 0) < (numberToInt(position.left) + numberToInt(width) | 0)) {
          var newLeft = {v: numberToInt(parentPos.left)};
          newLeft.v = newLeft.v + (numberToInt(parentWid) / 2 | 0) | 0;
          newLeft.v = newLeft.v - (numberToInt(width) / 2 | 0) | 0;
          var $receiver_0 = new Object_init();
          $receiver_0.left = newLeft.v;
          datepicker.css($receiver_0);
        }}return Unit;
    };
  }
  DateTimeInput.prototype.initEventHandlers_93gwzk$_0 = function () {
    var tmp$, tmp$_0, tmp$_1;
    (tmp$ = getElementJQuery(this)) != null ? tmp$.on('dp.change', DateTimeInput$initEventHandlers$lambda(this)) : null;
    (tmp$_0 = getElementJQuery(this)) != null ? tmp$_0.on('dp.error', DateTimeInput$initEventHandlers$lambda_0(this)) : null;
    (tmp$_1 = getElementJQuery(this)) != null ? tmp$_1.on('dp.show', DateTimeInput$initEventHandlers$lambda_1(this)) : null;
  };
  DateTimeInput.prototype.bindAllJQueryListeners = function () {
    bindAllJQueryListeners(this, this.jqueryListenersMap);
  };
  DateTimeInput.prototype.removeAllJQueryListeners = function () {
    removeAllJQueryListeners(this, this.jqueryListenersMap);
  };
  DateTimeInput.prototype.getValueAsString = function () {
    var tmp$;
    return (tmp$ = this.value) != null ? toStringF(tmp$, this.format) : null;
  };
  DateTimeInput.prototype.focus = function () {
    this.input.focus();
  };
  DateTimeInput.prototype.blur = function () {
    this.input.blur();
  };
  DateTimeInput.prototype.getState = function () {
    return this.value;
  };
  function DateTimeInput$subscribe$lambda(this$DateTimeInput, closure$observer) {
    return function () {
      var $receiver = this$DateTimeInput.observers;
      var element = closure$observer;
      $receiver.remove_11rb$(element);
      return Unit;
    };
  }
  DateTimeInput.prototype.subscribe_qlkmfe$ = function (observer) {
    this.observers.add_11rb$(observer);
    observer(this.value);
    return DateTimeInput$subscribe$lambda(this, observer);
  };
  DateTimeInput.prototype.setState_11rb$ = function (state) {
    this.value = state;
  };
  function DateTimeInput$Companion() {
    DateTimeInput$Companion_instance = this;
    BootstrapDatetimeModule_getInstance().initialize();
  }
  DateTimeInput$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var DateTimeInput$Companion_instance = null;
  function DateTimeInput$Companion_getInstance() {
    if (DateTimeInput$Companion_instance === null) {
      new DateTimeInput$Companion();
    }return DateTimeInput$Companion_instance;
  }
  function DateTimeInput$addon$lambda(this$DateTimeInput, closure$format) {
    return function ($receiver) {
      this$DateTimeInput.icon_w65uco$_0 = icon($receiver, this$DateTimeInput.getIconClass_gz0f8m$_0(closure$format));
      return Unit;
    };
  }
  function DateTimeInput$format$lambda(this$DateTimeInput) {
    return function (it) {
      this$DateTimeInput.refreshDatePicker();
      return Unit;
    };
  }
  function DateTimeInput$daysOfWeekDisabled$lambda(this$DateTimeInput) {
    return function (it) {
      this$DateTimeInput.refreshDatePicker();
      return Unit;
    };
  }
  function DateTimeInput$showClear$lambda(this$DateTimeInput) {
    return function (it) {
      this$DateTimeInput.refreshDatePicker();
      return Unit;
    };
  }
  function DateTimeInput$showClose$lambda(this$DateTimeInput) {
    return function (it) {
      this$DateTimeInput.refreshDatePicker();
      return Unit;
    };
  }
  function DateTimeInput$showTodayButton$lambda(this$DateTimeInput) {
    return function (it) {
      this$DateTimeInput.refreshDatePicker();
      return Unit;
    };
  }
  function DateTimeInput$stepping$lambda(this$DateTimeInput) {
    return function (it) {
      this$DateTimeInput.refreshDatePicker();
      return Unit;
    };
  }
  function DateTimeInput$minDate$lambda(this$DateTimeInput) {
    return function (it) {
      this$DateTimeInput.refreshDatePicker();
      return Unit;
    };
  }
  function DateTimeInput$maxDate$lambda(this$DateTimeInput) {
    return function (it) {
      this$DateTimeInput.refreshDatePicker();
      return Unit;
    };
  }
  function DateTimeInput$sideBySide$lambda(this$DateTimeInput) {
    return function (it) {
      this$DateTimeInput.refreshDatePicker();
      return Unit;
    };
  }
  function DateTimeInput$enabledDates$lambda(this$DateTimeInput) {
    return function (it) {
      this$DateTimeInput.refreshDatePicker();
      return Unit;
    };
  }
  function DateTimeInput$disabledDates$lambda(this$DateTimeInput) {
    return function (it) {
      this$DateTimeInput.refreshDatePicker();
      return Unit;
    };
  }
  function DateTimeInput$ignoreReadonly$lambda(this$DateTimeInput) {
    return function (it) {
      this$DateTimeInput.refreshDatePicker();
      return Unit;
    };
  }
  function DateTimeInput$inline$lambda(this$DateTimeInput) {
    return function (it) {
      this$DateTimeInput.refreshDatePicker();
      return Unit;
    };
  }
  function DateTimeInput$keepOpen$lambda(this$DateTimeInput) {
    return function (it) {
      this$DateTimeInput.refreshDatePicker();
      return Unit;
    };
  }
  function DateTimeInput$focusOnShow$lambda(this$DateTimeInput) {
    return function (it) {
      this$DateTimeInput.refreshDatePicker();
      return Unit;
    };
  }
  DateTimeInput.$metadata$ = {kind: Kind_CLASS, simpleName: 'DateTimeInput', interfaces: [MutableState, FormInput, GenericFormComponent, SimplePanel]};
  var package$io = _.io || (_.io = {});
  var package$kvision = package$io.kvision || (package$io.kvision = {});
  Object.defineProperty(package$kvision, 'BootstrapDatetimeModule', {get: BootstrapDatetimeModule_getInstance});
  Object.defineProperty(DateTime, 'Companion', {get: DateTime$Companion_getInstance});
  var package$form = package$kvision.form || (package$kvision.form = {});
  var package$time = package$form.time || (package$form.time = {});
  package$time.DateTime = DateTime;
  $$importsForInline$$['kvision-js-legacy'] = $module$kvision_js_legacy;
  Object.defineProperty(DateTimeInput, 'Companion', {get: DateTimeInput$Companion_getInstance});
  package$time.DateTimeInput = DateTimeInput;
  Object.defineProperty(DateTime.prototype, 'disabled', Object.getOwnPropertyDescriptor(DateFormControl.prototype, 'disabled'));
  Object.defineProperty(DateTime.prototype, 'name', Object.getOwnPropertyDescriptor(DateFormControl.prototype, 'name'));
  Object.defineProperty(DateTime.prototype, 'size', Object.getOwnPropertyDescriptor(DateFormControl.prototype, 'size'));
  Object.defineProperty(DateTime.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(DateFormControl.prototype, 'validationStatus'));
  Object.defineProperty(DateTime.prototype, 'validatorError', Object.getOwnPropertyDescriptor(DateFormControl.prototype, 'validatorError'));
  DateTime.prototype.getValue = DateFormControl.prototype.getValue;
  DateTime.prototype.setValue_s8jyv4$ = DateFormControl.prototype.setValue_s8jyv4$;
  DateTime.prototype.styleForHorizontalFormPanel_fn6884$ = DateFormControl.prototype.styleForHorizontalFormPanel_fn6884$;
  DateTime.prototype.styleForInlineFormPanel = DateFormControl.prototype.styleForInlineFormPanel;
  DateTime.prototype.styleForVerticalFormPanel = DateFormControl.prototype.styleForVerticalFormPanel;
  DEFAULT_STEPPING = 5;
  return _;
}));

//# sourceMappingURL=kvision-kvision-bootstrap-datetime-js-legacy.js.map
